export default __webpack_public_path__ + "a171f1b.png";